import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class CruiseMilesBehaviour extends AbstractDataAttributeBehaviour {

    attrSelectors = {
        priceValue: 'data-cruise-miles',
        display: 'data-cruise-miles-display'
    };

    getContainerSelector()
    {
        return '[' + this.attrSelectors.priceValue + ']';
    }

    initContainer(container)
    {
        let value = container.getAttribute(this.attrSelectors.priceValue);
        let displayElements = document.querySelectorAll('[' + this.attrSelectors.display + ']');
        for (let i=0; i< displayElements.length; i++) {
            displayElements[i].innerText = value;
        }

    }
}

